import axios from 'axios';

const TIMEOUT_ERROR_MESSAGE = 'timeoutErrorMessage';

axios.defaults.timeout = 20000;
axios.defaults.timeoutErrorMessage = TIMEOUT_ERROR_MESSAGE;

let instanceGBarbosa = axios.create({
    baseURL: process.env.REACT_APP_API_LINK_STORE
});

let instanceMercantil = axios.create({
    baseURL: process.env.REACT_APP_API_LINK_STORE
});

let instancePrezunic = axios.create({
    baseURL: process.env.REACT_APP_API_LINK_STORE
});

let instanceBretas = axios.create({
    baseURL: process.env.REACT_APP_API_LINK_STORE
});

let instancePerini = axios.create({
    baseURL: process.env.REACT_APP_API_LINK_STORE
});

let instanceSpid = axios.create({
  baseURL: process.env.REACT_APP_API_LINK_STORE
});

instanceGBarbosa.interceptors.request.use(
    async (config) => {

        config.headers = {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY_STORE,
            AplicativoId: "308238f8-1ccc-788c-982e-4ed43e7b51e6"
        };

        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

instanceMercantil.interceptors.request.use(
    async (config) => {

        config.headers = {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY_STORE,
            AplicativoId: "807238f8-1ccc-488c-982e-4ed43e7b51e6"
        };

        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

instancePrezunic.interceptors.request.use(
    async (config) => {

        config.headers = {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY_STORE,
            AplicativoId: "908238f8-1ccc-488c-982e-4ed43e7b51e6"
        };

        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

instanceBretas.interceptors.request.use(
    async (config) => {

        config.headers = {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY_STORE,
            AplicativoId: "108238f8-1ccc-488c-982e-4ed43e7b51e6"
        };

        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

instancePerini.interceptors.request.use(
    async (config) => {

        config.headers = {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY_STORE,
            AplicativoId: "408238f8-1ccc-488c-982e-4ed43e7b51e6"
        };

        return config;
    },
    (err) => {
        return Promise.reject(err);
    }
);

instanceSpid.interceptors.request.use(
  async (config) => {

      config.headers = {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY_STORE,
          AplicativoId: "708238f8-1ccc-488c-982e-4ed43e7b51e6"
      };

      return config;
  },
  (err) => {
      return Promise.reject(err);
  }
);


export const httpGBarbosa = instanceGBarbosa;
export const httpMercantil = instanceMercantil;
export const httpPrezunic = instancePrezunic;
export const httpBretas = instanceBretas;
export const httpPerini = instancePerini;
export const httpSpid = instanceSpid;
